export default __webpack_public_path__ + "static/media/massup_s3.72fa36ca.png";